import Configuration from './configuration';

const Domain = [
    Configuration
];

export default Domain;